import React from 'react';
import classNames from 'classnames';
import { deepClone } from '@monash/portal-frontend-common';
import { Icon } from '@monash/portal-react';
import BottomSheet from '@/components/ui/bottom-sheet/BottomSheet';
import { getShortcut, getShortcutIndex } from '../../utils';
import c from './edit-shortcuts-bottom-sheet.module.scss';

const EditShortcutsBottomSheet = ({
  isOpen,
  onClose,
  editedId,
  inEditShortcuts,
  setInEditShortcuts,
  setIsListDirty,
  onEdit,
}) => {
  const shortcut = getShortcut(editedId, inEditShortcuts);
  const shortcutIndex = getShortcutIndex(editedId, inEditShortcuts);
  const isFirst = shortcutIndex === 0;
  const isLast = shortcutIndex === inEditShortcuts.length - 1;

  const moveShortcutUp = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const currentIndex = getShortcutIndex(shortcut.id, newShortcuts);
      if (currentIndex > 0) {
        const temp = newShortcuts[currentIndex - 1];
        newShortcuts[currentIndex - 1] = newShortcuts[currentIndex];
        newShortcuts[currentIndex] = temp;
      }
      return newShortcuts;
    });
  };

  const moveShortcutDown = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const currentIndex = getShortcutIndex(shortcut.id, newShortcuts);
      if (currentIndex < newShortcuts.length - 1) {
        const temp = newShortcuts[currentIndex + 1];
        newShortcuts[currentIndex + 1] = newShortcuts[currentIndex];
        newShortcuts[currentIndex] = temp;
      }
      return newShortcuts;
    });
  };

  const deleteInEditShortcut = () => {
    setIsListDirty(true);
    setInEditShortcuts((shortcuts) => {
      const newShortcuts = deepClone(shortcuts);
      const inEditShortcutIndex = getShortcutIndex(shortcut.id, newShortcuts);
      newShortcuts.splice(inEditShortcutIndex, 1);
      return newShortcuts;
    });
    onClose();
  };

  const handleEdit = () => {
    onEdit(shortcut.id);
    onClose();
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className={c.editShortcutsBottomSheet}>
        <button
          className={c.action}
          onClick={moveShortcutUp}
          aria-label="Move shortcut up"
          disabled={isFirst}
          type="button"
        >
          <Icon.ChevronUp /> Move up
        </button>

        <button
          className={c.action}
          onClick={moveShortcutDown}
          aria-label="Move shortcut down"
          disabled={isLast}
          type="button"
        >
          <Icon.ChevronDown /> Move down
        </button>

        <button
          className={c.action}
          onClick={handleEdit}
          aria-label="Edit shortcut"
          type="button"
        >
          <Icon.Pencil /> Edit
        </button>

        <button
          className={classNames(c.action, c.trash)}
          onClick={deleteInEditShortcut}
          aria-label="Delete shortcut"
          type="button"
        >
          <Icon.Trash /> Delete
        </button>
      </div>
    </BottomSheet>
  );
};

export default EditShortcutsBottomSheet;
